import { Grid, makeStyles, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { getCountries } from "../../../../../../../utils/getCountries";
import { BasicUserUpdate } from "../interfaces/BasicUserUpdate";

const useStyles = makeStyles((theme) => ({
  input: {
    marginBottom: "20px",
    border: `2px solid #fee9ee`,
    borderRadius: "12px",
    height: "52px",
    background: theme.palette.background.default,
    transition: "background .25s, border .25s",
    "& .MuiInputBase-root.MuiAutocomplete-inputRoot > .MuiAutocomplete-input": {
      padding: "22px 12px 10px !important",
    },
    "& .MuiInputBase-root.MuiAutocomplete-inputRoot": {
      padding: "0px !important",
    },
    "&.MuiAutocomplete-root:has(.Mui-focused)": {
      border: "2px solid #FD9BB5",
      background: "#fee9ee",
    },
    "& .MuiFilledInput-root": {
      background: "none",
      height: "46px",
    },
    "& .MuiFilledInput-underline:after": {
      borderBottom: "none",
    },
    "& .MuiFilledInput-underline:before": {
      borderBottom: "none",
    },
  },
  middleButton: {
    paddingLeft: "4px",
    paddingRight: "4px",
  },
  leftButton: {
    paddingRight: "4px",
  },
  rightButton: {
    paddingLeft: "4px",
  },
  title: {
    marginBottom: "8px",
  },
}));

interface Props {
  translations: {
    title: string;
    label: string;
  };
  defaultCountry: string;
  setBasicUserData: (data: Partial<BasicUserUpdate>) => void;
  loading: boolean;
}

export const CountryInput: React.FC<Props> = (props) => {
  const { translations, setBasicUserData, defaultCountry, loading } = props;
  const classes = useStyles();
  const countries = getCountries;
  const [selectedCountry, setSelectedCountry] = useState<string>(
    defaultCountry && countries.find((c) => c.value === defaultCountry)
      ? defaultCountry
      : null
  );

  useEffect(() => {
    if (selectedCountry) {
      setBasicUserData({ country: selectedCountry });
    } else {
      setBasicUserData({ country: null });
    }
  }, [selectedCountry]);

  return (
    <Grid container direction="column">
      <Grid item xs={12}>
        <Typography variant="h6" className={classes.title}>
          {translations.title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          disabled={loading}
          disableClearable
          className={classes.input}
          options={countries}
          getOptionLabel={(c) => c.value}
          onChange={(_, c: { key: string; value: string }) => {
            if (c) {
              setSelectedCountry(c.value);
            } else {
              setSelectedCountry(null);
            }
          }}
          defaultValue={countries.find((c) => c.value === selectedCountry)}
          renderInput={(params) => (
            <TextField
              required
              {...params}
              label={translations.label}
              fullWidth
              variant="filled"
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
